<script setup lang="ts">
import LogoIcon from '@/assets/icons/core/logo.svg';
import { Theme } from '@/modules/common/enums/theme.ts';

const isChristmasTheme = import.meta.env.VITE_BUILD_THEME === Theme.Christmas;
</script>

<template>
  <div class="app-logo">
    <img
      v-if="isChristmasTheme"
      class="snow"
      src="@/assets/images/snow-logo.png"
      alt=""
    />
    <LogoIcon
      class="icon"
      :alt="$t('core.common.title')"
    />
  </div>
</template>

<style scoped lang="scss">
.app-logo {
  position: relative;
}

.snow {
  position: absolute;
  top: 5%;
  left: 7%;
  width: 75%;
}

.icon {
  width: 100%;
  height: 100%;
}
</style>
